import jwt_decode from "jwt-decode";

export const getExpirationTime = (jwtToken) => {
  if (!jwtToken) {
    return null;
  }
  try {
    const jwt = jwt_decode(jwtToken);
    var expiresIn = (jwt && jwt.exp && jwt.exp * 1000) || null;
    if (!expiresIn) {
      return null;
    }
    const expirationTime = new Date(expiresIn);
    return expirationTime.toISOString();
  } catch {}
  return null;
};

export const getRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();
  const remainingDuration = adjExpirationTime - currentTime;
  return remainingDuration;
};
